import React from 'react'
import Header from '../../component/Header/Header'
import HomeHero from '../../component/HomeHero/HomeHero'
import Footer from '../../component/Footer/Footer'
import BoxedContent from '../../component/BoxedContent/BoxedContent'
import SlideScrollContent from '../../component/SlideScrollContent/SlideScrollContent'
import BoostCard from '../../component/BoostCard/BoostCard'
import TeamLdCare from '../../component/TeamLdCare/TeamLdCare'
import HomeProgram from '../../component/HomeProgram/HomeProgram'
import BoostshootRowCard from '../../component/BoostshootRowCard/BoostshootRowCard'
import { Helmet } from 'react-helmet'

const cardD = [
  {
    img: false,
    title: "Consultation",
    para:'A clinician reviews your needs and goals to select or design your infusion.',
    number:"01",
    id: 1,
  },
  {
    img: false,
    title: "Preparation",
    para:'Ingredients are compounded on-site under strict medical supervision.',
    number:"02",
    id: 2,
  },
  {
    img: false,
    title: "Infusion",
    para:' Relax in a lounge setting while receiving your personalized IV, usually over 45–60 minutes.',
    number:"03",
    id: 3,
  },
]

const cardList = [
  {
    link:"/naturopathic-medicine",
    img:"/images/creatives/service-main-9.webp",
    name:"Naturopathic Medicine",
    rank:"",
    para:'An integrative approach combining clinical science and natural therapies to optimize health.'
  },
  {
    link:"/medical-aesthetics",
    img:"/images/creatives/service-main-6.webp",
    name:"Medical Aesthetics",
    rank:"",
    para:'Enhanced aesthetic treatments for natural and confident results.'
  },
]

const boostCardData = [
  "Restore hydration and electrolyte balance",
  "Replenish essential nutrients and antioxidants",
  "Support immune health and reduce fatigue",
  "Promote skin vitality and post-travel recovery",

]

function BoostShoot() {
  return (
    <div style={{backgroundColor:"#FEFCF0"}}>
      <Helmet>
        <title>
        IV Therapy Toronto | IV Drip, Hydration & Vitamin Infusions
        </title>
        {/* <meta name="keywords" 
        content=""
        ></meta> */}
        <link
          rel="canonical"
          href="https://thetorontoclinic.com/iv-therapy-boost-shots"
        />
        <meta
          name="description"
          content="Replenish energy with IV therapy Toronto. Our IV vitamin drips and hydration infusions deliver essential nutrients, boost recovery, and enhance overall wellness."
        ></meta>
       
      </Helmet>
         <Header/>
        <HomeHero
            heading='IV Therapy and boost shots'
            content='Targeted hydration and nutrient infusions for energy, recovery, and resilience.'
            textCtaBlack={true}
            headingBlack={true}
            showLogo={false}
            plainCta={false}
            btnText='Book a Consultation'
            btnrefTel='https://booking.thetorontoclinic.com/services-general'
            sideImage={"/images/creatives/boostshotshero-image.png"}
            // bgImage={"/images/creatives/boost-shoot-bg.png"}
            bgImage={"/images/creatives/gradient-bg-3.png"}
            btnCalnedly={true}
            calendlyType={3}
        />

        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
          <div className='pt-4'></div>
          <BoxedContent
            heading="Formulas for an empowered you"
            para="IV Therapy delivers a customized blend of vitamins, minerals, and hydration directly into your bloodstream for rapid absorption and optimal effect. Whether you're recovering from travel, managing stress, or boosting immunity, our infusions are tailored to your unique needs."
            bgImg="/images/creatives/service-main-8.webp"
          />

          <div className='pt-4'></div>
          {/* <SlideScrollContent
            cardData={cardD}
            noContent={true}
          /> */}
          <BoostshootRowCard
            cards={cardD}
          />
          <div className='pb-5'></div>
        </div>

        {/* <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}> */}
        <div style={{backgroundImage:"url(/images/creatives/boost-shoot-bg.png)",backgroundPosition:"center",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>

        <BoostCard
          cardContentProp={boostCardData}
        />

        
        <div className='pt-4'></div>
       <TeamLdCare
          heading=''
          spanHeading="Enhance your experience"
          paragraph="Add a boost or complementary care to elevate the benefits of your IV session."
          showBtn={false}
          cardData={cardList}
          noSwiper={true}
       /> 
        <div className='pb-4'></div>
        
        </div>
<div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"bottom",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
        <HomeProgram
          mainCardHeading="The path to health begins here, take the first step"
          mainCardPara="At The Toronto Clinic, we redefine healthcare with a proactive, deeply personalized approach. Designed to support your longevity and well-being, our program ensures you stay at your peak: healthy, confident, and in control."
          btnText="Explore membership"
          btnRef="/membership"
          mainCardImg={"/images/creatives/membership-text-2.png"}
          showList={false}
          leftBottomBorderRadius={true}
          backgroundPlain={true}
        />
        
        <Footer
          newsletterSection={false}
        />
        </div>
    </div>
  )
}

export default BoostShoot